<div class="modal-body pt-5">
  <ngb-alert type="danger" [dismissible]="false" class="d-flex p-1 pt-0 pb-0 mb-0 align-items-center">
    <fa-icon [icon]="faExclamation" class="fa mr-2 ml-2" style="font-size: 2.5em"></fa-icon>
    {{message}}
  </ngb-alert>
</div>

<div class="d-flex justify-content-end pb-2 mr-3">
  <button
    (click)="activeModal.close('cancel')"
    class="btn btn-sm btn-outline-secondary ml-auto mr-2"
    id="cancelButton"
    type="button"
  >Cancel</button>
  <button
    (click)="activeModal.close('continue')"
    class="btn btn-sm btn-main-danger"
    id="continueButton"
  >Continue</button>
</div>
